import type { ExternalTableSchema } from '@packages/table-builder';

const historicalStockPriceColumnPreferences = {
  persistenceKey: 'Historical Stock Price',
  resizable: true,
  reorderable: true,
};

export const historicalStockPriceTable: ExternalTableSchema = {
  metadata: {
    title: 'Historical Stock Price',
    entity: 'HistoricalStockPrice',
    description: 'Historical stock price data.',
  },

  dataSource: {
    endpoint: '/api/finance-integration/api/app/stock/historical-stock-price',
    method: 'GET',
    rowIdField: 'date',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      FromDate: 'filters.fromDate',
      ToDate: 'filters.toDate',
    },
    filters: [
      {
        name: 'fromDate',
        placeholder: 'Start Date',
        type: 'date',
      },
      {
        name: 'toDate',
        placeholder: 'End Date',
        type: 'date',
      },
    ],
  },

  columns: [
    {
      field: 'date',
      header: 'Date',
      type: 'date',
      width: 200,
      sortable: true,
    },
    {
      field: 'openPrice',
      header: 'Open Price',
      type: 'currency',
      width: 200,
      align: 'center',
      sortable: true,
      format: { decimals: 2 },
    },
    {
      field: 'highPrice',
      header: 'High Price',
      type: 'currency',
      width: 200,
      align: 'center',
      sortable: true,
      format: { decimals: 2 },
    },
    {
      field: 'lowPrice',
      header: 'Low Price',
      type: 'currency',
      width: 200,
      align: 'center',
      sortable: true,
      format: { decimals: 2 },
    },
    {
      field: 'closePrice',
      header: 'Close Price',
      type: 'currency',
      width: 200,
      align: 'center',
      format: { decimals: 2 },
    },
    {
      field: 'closePriceStatus',
      header: 'Status',
      type: 'text',
      width: 140,
      align: 'center',
      sortable: false,
    },
  ],

  actions: {
    toolbar: {
      secondary: [
        {
          label: 'Export',
          icon: 'download',
          type: 'download',
          children: [
            { id: 'EXPORT_HISTORICAL_STOCK_PRICE', label: 'Export Historical Stock Price' },
          ],
        },
      ],
    },
  },

  features: {
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: historicalStockPriceColumnPreferences,
  },
};

/** Same columns as the list page — past 30 days API, no filters or export (modal embeds). */
export const historicalStockPriceModalTable: ExternalTableSchema = {
  metadata: {
    title: 'List of past 30 days',
    entity: historicalStockPriceTable.metadata.entity,
    description: historicalStockPriceTable.metadata.description,
  },
  dataSource: {
    endpoint: '/api/finance-integration/api/app/stock/one-month-stock-data',
    method: 'GET',
    rowIdField: 'date',
    requestParams: {
      Filter: 'static.undefined',
      MaxResultCount: 'static.undefined',
      SkipCount: 'static.undefined',
      Sorting: 'static.undefined',
    },
  },
  columns: historicalStockPriceTable.columns,
  features: {
    search: { enabled: false },
    pagination: { mode: 'none' },
    virtualScroll: { enabled: true },
    columnPreferences: historicalStockPriceColumnPreferences,
  },
};
